/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StatsBillingGetResponse } from './StatsBillingGetResponse';
import {
    StatsBillingGetResponseFromJSON,
    StatsBillingGetResponseFromJSONTyped,
    StatsBillingGetResponseToJSON,
    StatsBillingGetResponseToJSONTyped,
} from './StatsBillingGetResponse';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
    APIResponseErrorToJSONTyped,
} from './APIResponseError';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
    APIMetaToJSONTyped,
} from './APIMeta';

/**
 * 
 * @export
 * @interface GetStatsBilling200Response
 */
export interface GetStatsBilling200Response {
    /**
     * 
     * @type {APIMeta}
     * @memberof GetStatsBilling200Response
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof GetStatsBilling200Response
     */
    errors?: Array<APIResponseError>;
    /**
     * 
     * @type {StatsBillingGetResponse}
     * @memberof GetStatsBilling200Response
     */
    result: StatsBillingGetResponse;
}

/**
 * Check if a given object implements the GetStatsBilling200Response interface.
 */
export function instanceOfGetStatsBilling200Response(value: object): value is GetStatsBilling200Response {
    if (!('result' in value) || value['result'] === undefined) return false;
    return true;
}

export function GetStatsBilling200ResponseFromJSON(json: any): GetStatsBilling200Response {
    return GetStatsBilling200ResponseFromJSONTyped(json, false);
}

export function GetStatsBilling200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetStatsBilling200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'meta': json['meta'] == null ? undefined : APIMetaFromJSON(json['meta']),
        'errors': json['errors'] == null ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
        'result': StatsBillingGetResponseFromJSON(json['result']),
    };
}

export function GetStatsBilling200ResponseToJSON(json: any): GetStatsBilling200Response {
    return GetStatsBilling200ResponseToJSONTyped(json, false);
}

export function GetStatsBilling200ResponseToJSONTyped(value?: GetStatsBilling200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'meta': APIMetaToJSON(value['meta']),
        'errors': value['errors'] == null ? undefined : ((value['errors'] as Array<any>).map(APIResponseErrorToJSON)),
        'result': StatsBillingGetResponseToJSON(value['result']),
    };
}

